import { preloadAllResultsQuery } from '#pplx/frontend/apps/ask/all-results/hooks/allResultsQuery.js';
import { buildThreadEntriesPreloadParams } from '#pplx/frontend/apps/ask/all-results/hooks/threadEntriesPreload.js';
import { emitThreadPagesPreload } from '#pplx/frontend/apps/ask/page-components/thread-pages-preload/threadPagesPreloadEvent.js';
import { useQueryClientProviderConfig } from '#pplx/frontend/react-query/QueryClientProviderContext.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
const PREFETCH_REASON = 'sidebar-thread-prefetch';
function allowsSpeculativeFetch() {
    const connection = navigator.connection;
    if (!connection)
        return true;
    if (connection.saveData)
        return false;
    if (connection.downlink !== undefined && connection.downlink < 1)
        return false;
    return connection.effectiveType !== 'slow-2g' && connection.effectiveType !== '2g';
}
export function usePrefetchThreadEntriesFactory() {
    const queryClient = useQueryClient();
    const { allowPersist } = useQueryClientProviderConfig();
    return useCallback(({ slugOrUUID, surface, enabled = true }) => {
        if (!enabled || !slugOrUUID || !allowsSpeculativeFetch())
            return;
        emitThreadPagesPreload(surface);
        void preloadAllResultsQuery(buildThreadEntriesPreloadParams({
            queryClient,
            allowPersist,
            slugOrUUID,
            surface,
            reason: PREFETCH_REASON,
        }));
    }, [allowPersist, queryClient]);
}
export function usePrefetchThreadEntries(options) {
    const prefetch = usePrefetchThreadEntriesFactory();
    const { slugOrUUID, surface, enabled } = options;
    return useCallback(() => prefetch({ slugOrUUID, surface, enabled }), [prefetch, slugOrUUID, surface, enabled]);
}
//# sourceMappingURL=usePrefetchThreadEntries.js.map